<template>
  <div>
    
    <p class='title is-1'>special mentions</p>
    <div class='myTile'>
      <p class='title is-3 is-6-mobile'>Dirtiest user</p>
      <font-awesome-icon icon="dizzy" class='title icon is-large is-medium-mobile'/>
      <div class='has-text-left'>
        <p>In the underlying data, users could technically be infected by the virus more than once. Shout out to <span class='userName'>{{ dirtiestUser.user }}</span> for catching the virus more than anyone else, a jaw-dropping <span class='myNumber'>{{ dirtiestUser.num }}</span> times.</p>
      </div>
    </div>

    <div class='myTile'>
      <p class='title is-3 is-6-mobile'>Dirtiest comment</p>      
      <font-awesome-icon icon="biohazard" class='title icon is-large is-medium-mobile'/>
      <div class='has-text-left'>
        <p>This comment from <span class='userName'>{{ dirtiestComment.user }}</span> infected <span class='myNumber'>{{ dirtiestComment.num }}</span> users, more than any other during the infection.</p>
        <br>
        <div class='quote'>
          <p>"To clear this up: Replying to an infected person's comment will definitely make you infected. Commenting on a post made by an infected person has a 1% chance of making you infected."</p>
          <p>
            <a class='is-info' href='https://www.reddit.com/r/memes/comments/fm5k7j/rmemes_memonavirus_update_thread/fl3zlqu/'>permalink</a>
          </p>
        </div>
      </div>
    </div>


    <div class='myTile'>
      <p class='title is-3 is-6-mobile'>Best hygiene</p>
      <font-awesome-icon icon="hands-wash" class='title icon is-large is-medium-mobile'/>
      <div class='has-text-left'>
        <p>User <span class='userName'>{{ bestHygiene.user }}</span> spent the longest time infected <span>without</span> spreading the virus to any other users: <span class='myNumber'>{{ bestHygiene.time }}</span>.</p>
      </div>
    </div>

    <div class='myTile'>
      <p class='title is-3 is-6-mobile'>Luckiest user</p>
      <font-awesome-icon icon="dice" class='title icon is-large is-medium-mobile'/>
      <div class='has-text-left'>
        <p>No one rolled the dice more than <span class='userName'>{{ luckiestUser.user }}</span> who made <span class='myNumber'>{{ luckiestUser.comments }}</span> comments on the posts of previously-infected users before finally succumbing to the virus.</p>     
      </div>
    </div>
  
  </div>

</template>

<script>
  export default {
    data() {
      return {
        dirtiestUser: {
          'user': 'effective_techer',
          'num': 70
        },
        dirtiestComment: {
          'num': 300,
          'user': 'Kind-Pop',
          'date': 'March 21, 2020'
        },
        bestHygiene: {
          'user': 'bappodrinklacto',  
          'time': '27 days, 19 hours, and 2 minutes'
        },
        luckiestUser: {
          'user': 'porntipsguzzardobot',
          'comments': 173
        },
      }
    }
  }
  
</script>


<style scoped>

div.quote {
  font-style: italic;
  overflow-wrap: break-word;
}

</style>